export const sizePerPageList = [
    { text: '10', value: 10 },
    { text: '20', value: 20 },
    { text: '50', value: 30 },
];

export const initialFilter = {
    filter: {
        is_name: "true",
        name: "",
        donation_hid: '',
        status: '',
        thk_livestock_uuid: '',
        chName: '',
        date: '',
    },
    pageNumber: 1,
    pageSize: 10
};

export const badge = (status) => {
    let data = {};
    switch (status) {
        case 'RECOG':
            data = { text: 'RECOG', type: 'info' };
            break;
        case 'SETTLE':
            data = { text: 'SETTLE', type: 'success' };
            break;
        case 'VOID':
            data = { text: 'VOID', type: 'danger' };
            break;
        case 'REQUEST_VOID':
            data = { text: 'REQUEST_VOID', type: 'warning' };
            break;
        default:
            data = { text: status, type: 'primary' };
    }


    return data;
};

const STATUS_KURBAN = {
  WAITING_PARTNER: "WAITING_PARTNER",
  ACCEPTED_PARTNER: "ACCEPTED_PARTNER",
  EXECUTED: "EXECUTED",
  REPORTED: "REPORTED",
  FINISH: "FINISH",
};

const STATUS_KURBAN_DESC = {
  WAITING_PARTNER: "BELUM DIPROSES",
  ACCEPTED_PARTNER: "DITERIMA MITRA",
  EXECUTED: "DIPOTONG",
  REPORTED: "DILAPORKAN",
  FINISH: "SELESAI",
};

export const statusKurbanBadge = (status) => {
  let data = {};
  switch (status) {
    case STATUS_KURBAN.WAITING_PARTNER:
        data = { text: STATUS_KURBAN_DESC[status], type: "dark" };
        break;
    case STATUS_KURBAN.ACCEPTED_PARTNER:
        data = { text: STATUS_KURBAN_DESC[status], type: "primary" };
        break;
    case STATUS_KURBAN.EXECUTED:
        data = { text: STATUS_KURBAN_DESC[status], type: "danger" };
        break;
    case STATUS_KURBAN.REPORTED:
        data = { text: STATUS_KURBAN_DESC[status], type: "info" };
        break;
    case STATUS_KURBAN.FINISH:
        data = { text: STATUS_KURBAN_DESC[status], type: "success" };
        break;
    default:
      data = { text: status, type: "primary" };
  }

  return data;
};

export const TIPE_HEWAN_HELPER = [
  { value: "SAPI", text: "Sapi" },
  { value: "17_SAPI", text: "1/7 Sapi" },
  { value: "KAMBING", text: "Kambing" },
];
